/*-----------------------------------------------------------------------------/
/ DTDC Shipment Tracking — Venue theme integration
/-----------------------------------------------------------------------------*/

(function () {
  var STATUS_MAP = {
    BKD: "Booked",
    PCAW: "Pickup Awaited",
    PCSC: "Pickup Scheduled",
    PCRA: "Pickup Reassigned",
    PCUP: "Picked Up",
    OUTDLV: "Out For Delivery",
    NONDLV: "Not Delivered",
    DLV: "Delivered",
    HLDUP: "Held Up",
    RTO: "Returned To Origin"
  };

  var ERROR_MESSAGES = {
    INVALID_TRACKING: "No shipment found.",
    NOT_FOUND: "No shipment found.",
    API_FAILURE: "Unable to fetch tracking information. Please try again later.",
    NETWORK_FAILURE: "Connection issue detected.",
    TOKEN_FAILURE: "Tracking service temporarily unavailable.",
    MISSING_ENDPOINT:
      "Tracking service is not configured. Please contact the store.",
    FORBIDDEN: "Tracking service is not available from this site.",
    UNAUTHORIZED: "Tracking service is not available.",
    EMPTY: "Please enter your DTDC tracking number.",
    TOO_SHORT: "Please enter a valid DTDC tracking number."
  };

  var MIN_TRACKING_LENGTH = 6;
  var TRACKING_PATTERN = /^[A-Za-z0-9-]+$/;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getStatusLabel(code, fallback) {
    if (!code) {
      return fallback || "";
    }
    var normalized = String(code).trim().toUpperCase();
    return STATUS_MAP[normalized] || fallback || normalized;
  }

  function getBadgeClass(statusCode, statusText) {
    var code = String(statusCode || "").toUpperCase();
    var text = String(statusText || "").toLowerCase();

    if (code === "NONDLV" || text.indexOf("not delivered") !== -1) {
      return "dtdc-tracking__status-badge--not-delivered";
    }
    if (code === "DLV" || text.indexOf("delivered") !== -1) {
      return "dtdc-tracking__status-badge--delivered";
    }
    if (code === "OUTDLV" || text.indexOf("out for delivery") !== -1) {
      return "dtdc-tracking__status-badge--out-for-delivery";
    }
    if (code === "HLDUP" || text.indexOf("held up") !== -1) {
      return "dtdc-tracking__status-badge--held-up";
    }
    return "dtdc-tracking__status-badge--unknown";
  }

  function validateTrackingNumber(value) {
    var trackingNumber = String(value || "").trim();
    if (!trackingNumber) {
      return { valid: false, error: "EMPTY" };
    }
    if (trackingNumber.length < MIN_TRACKING_LENGTH) {
      return { valid: false, error: "TOO_SHORT" };
    }
    if (!TRACKING_PATTERN.test(trackingNumber)) {
      return { valid: false, error: "INVALID_TRACKING" };
    }
    return { valid: true, trackingNumber: trackingNumber };
  }

  function setLoading(widget, isLoading) {
    var form = widget.querySelector(".js-dtdc-tracking-form");
    var loading = widget.querySelector(".js-dtdc-tracking-loading");
    var submit = widget.querySelector(".js-dtdc-tracking-submit");
    var input = widget.querySelector(".js-dtdc-tracking-input");

    widget.dataset.loading = isLoading ? "true" : "false";

    if (form) {
      form.classList.toggle("is-loading", isLoading);
      form.setAttribute("aria-busy", isLoading ? "true" : "false");
    }
    if (loading) {
      loading.hidden = !isLoading;
    }
    if (submit) {
      submit.disabled = isLoading;
    }
    if (input) {
      input.readOnly = isLoading;
    }
  }

  function showError(widget, message) {
    var errorEl = widget.querySelector(".js-dtdc-tracking-error");
    if (!errorEl) {
      return;
    }
    if (!message) {
      errorEl.textContent = "";
      errorEl.hidden = true;
      return;
    }
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function hideResults(widget) {
    var results = widget.querySelector(".js-dtdc-tracking-results");
    if (results) {
      results.hidden = true;
      results.innerHTML = "";
    }
  }

  function renderSummaryItem(label, value, isHtml) {
    if (!value) {
      return "";
    }
    return (
      '<div class="dtdc-tracking__summary-item">' +
      '<span class="dtdc-tracking__summary-label">' +
      escapeHtml(label) +
      "</span>" +
      '<p class="dtdc-tracking__summary-value">' +
      (isHtml ? value : escapeHtml(value)) +
      "</p>" +
      "</div>"
    );
  }

  function renderTimeline(timeline) {
    if (!Array.isArray(timeline) || !timeline.length) {
      return "";
    }

    var items = timeline
      .map(function (entry) {
        var action =
          escapeHtml(
            entry.action || getStatusLabel(entry.code, entry.action)
          ) || "Update";
        var meta = [entry.date, entry.time].filter(Boolean).join(" at ");
        var location = entry.location
          ? '<p class="dtdc-tracking__timeline-location">' +
            escapeHtml(entry.location) +
            "</p>"
          : "";
        var remarks = entry.remarks
          ? '<p class="dtdc-tracking__timeline-remarks">' +
            escapeHtml(entry.remarks) +
            "</p>"
          : "";

        return (
          '<li class="dtdc-tracking__timeline-item">' +
          '<p class="dtdc-tracking__timeline-action">' +
          action +
          "</p>" +
          (meta
            ? '<p class="dtdc-tracking__timeline-meta">' +
              escapeHtml(meta) +
              "</p>"
            : "") +
          location +
          remarks +
          "</li>"
        );
      })
      .join("");

    return (
      '<div class="dtdc-tracking__timeline">' +
      '<h3 class="dtdc-tracking__timeline-title">Shipment Timeline</h3>' +
      '<ol class="dtdc-tracking__timeline-list">' +
      items +
      "</ol>" +
      "</div>"
    );
  }

  function renderResults(data) {
    var statusLabel = escapeHtml(
      data.status || getStatusLabel(data.statusCode, "Unknown")
    );
    var badgeClass = getBadgeClass(data.statusCode, data.status);
    var statusHtml =
      '<span class="dtdc-tracking__status-badge ' +
      badgeClass +
      '">' +
      statusLabel +
      "</span>";

    var summary =
      '<div class="dtdc-tracking__summary">' +
      '<h3 class="dtdc-tracking__summary-title">Shipment Summary</h3>' +
      '<div class="dtdc-tracking__summary-grid">' +
      renderSummaryItem("Tracking Number", data.trackingNumber) +
      renderSummaryItem("Current Status", statusHtml, true) +
      renderSummaryItem("Origin", data.origin) +
      renderSummaryItem("Destination", data.destination) +
      renderSummaryItem("Booked Date", data.bookedDate) +
      renderSummaryItem("Expected Delivery Date", data.expectedDeliveryDate) +
      renderSummaryItem("Last Updated", data.lastUpdate) +
      "</div>" +
      "</div>";

    return summary + renderTimeline(data.timeline);
  }

  function mapApiError(payload) {
    if (!payload || !payload.error) {
      return ERROR_MESSAGES.API_FAILURE;
    }
    return ERROR_MESSAGES[payload.error] || payload.message || ERROR_MESSAGES.API_FAILURE;
  }

  function trackShipment(widget, trackingNumber) {
    if (widget.dataset.loading === "true") {
      return Promise.resolve();
    }

    var endpoint = (widget.dataset.apiEndpoint || "").trim();
    if (!endpoint) {
      showError(widget, ERROR_MESSAGES.MISSING_ENDPOINT);
      return Promise.resolve();
    }

    setLoading(widget, true);
    showError(widget, "");
    hideResults(widget);

    var headers = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };

    return fetch(endpoint, {
      method: "POST",
      credentials: "omit",
      headers: headers,
      body: JSON.stringify({ trackingNumber: trackingNumber })
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (payload) {
            return { response: response, payload: payload };
          });
      })
      .then(function (result) {
        if (!result.response.ok) {
          throw new Error(mapApiError(result.payload));
        }
        if (!result.payload || !result.payload.success) {
          throw new Error(mapApiError(result.payload));
        }

        var resultsEl = widget.querySelector(".js-dtdc-tracking-results");
        if (resultsEl) {
          resultsEl.innerHTML = renderResults(result.payload);
          resultsEl.hidden = false;
          if (resultsEl.focus) {
            resultsEl.setAttribute("tabindex", "-1");
            resultsEl.focus();
          }
        }
      })
      .catch(function (error) {
        var message =
          error && error.name === "TypeError"
            ? ERROR_MESSAGES.NETWORK_FAILURE
            : (error && error.message) || ERROR_MESSAGES.API_FAILURE;
        showError(widget, message);
      })
      .finally(function () {
        setLoading(widget, false);
      });
  }

  function bindWidget(widget) {
    if (widget.dataset.bound === "true") {
      return;
    }
    widget.dataset.bound = "true";

    var form = widget.querySelector(".js-dtdc-tracking-form");
    var input = widget.querySelector(".js-dtdc-tracking-input");
    if (!form || !input) {
      return;
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var validation = validateTrackingNumber(input.value);
      if (!validation.valid) {
        showError(widget, ERROR_MESSAGES[validation.error] || ERROR_MESSAGES.INVALID_TRACKING);
        hideResults(widget);
        input.focus();
        return;
      }
      trackShipment(widget, validation.trackingNumber);
    });

    input.addEventListener("input", function () {
      if (widget.querySelector(".js-dtdc-tracking-error:not([hidden])")) {
        showError(widget, "");
      }
    });

    var params = new URLSearchParams(window.location.search);
    var prefilled = params.get("tracking") || params.get("cn") || params.get("awb");
    if (prefilled) {
      input.value = prefilled.trim();
    }
  }

  function init() {
    document.querySelectorAll(".js-dtdc-tracking").forEach(bindWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) {
      return;
    }
    event.target.querySelectorAll(".js-dtdc-tracking").forEach(bindWidget);
  });
})();
